import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType } from "@/graphql";

const router: Router.LicensedRouterExportType = [
  {
    path: "/idea/settingsOverview",
    name: "SettingsOverview",
    component: () => import("./views/IdeaSiteList.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
  },
  {
    path: "/idea/configOverview",
    name: "IdeaConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
    props: {
      internalTypes: [SQDCEventActionTypeInternalType.HLPIdea],
      titleKey: "router.IdeaConfigOverview",
      detailRouteName: "IdeaConfigSettings",
    },
  },
  {
    path: "/idea/configOverview/:siteId",
    name: "IdeaConfigSettings",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigSettings.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
    props: (route) => ({
      internalTypes: [SQDCEventActionTypeInternalType.HLPIdea],
      siteId: Number(route.params.siteId),
      titleKey: "router.IdeaConfigSettings",
    }),
  },
  {
    path: "/idea/config/:siteId/:new?",
    name: "HLPConfig",
    component: () => import("./views/IdeaConfig.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
    props: (route) => {
      return {
        siteId: Number(route.params.siteId),
        create: route.params.new === "true",
      };
    },
  },
  {
    path: "/idea/categoryList",
    name: "HLPCategoryList",
    component: () => import("./views/IdeaCategoryList.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
  },
  {
    path: "/idea/category/:id",
    name: "HLPCategory",
    component: () => import("./views/IdeaCategory.vue"),
    meta: {
      rights: ["hlp.readWrite"],
    },
    props: (route) => {
      const newMode = route.params.id.toString() === "new";
      return {
        id: newMode ? undefined : parseInt(route.params.id.toString(), 10),
        newMode,
      };
    },
  },
];

export default router;
